import { render, staticRenderFns } from "./AlTextarea.vue?vue&type=template&id=1ef6fbbb&"
import script from "./AlTextarea.vue?vue&type=script&lang=js&"
export * from "./AlTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AlTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports